import { GridBlockType } from 'services/entities/BlockTypes';
import { gridDefaultDimensionsOnDrop } from 'components/editor/shared/gridConfig';
import IcoPlayDisabledRounded from 'components/icon/icons/IcoPlayDisabledRounded';

export default function EmptyVideoPlaceholder({ dimension }: { dimension: { width: number; height: number } }) {
  const scaleFactor = Math.min(
    dimension.width / gridDefaultDimensionsOnDrop[GridBlockType.VIDEO].width,
    dimension.height / gridDefaultDimensionsOnDrop[GridBlockType.VIDEO].height
  );

  const defaultWrapperSizeRem = 10;
  const defaultIconSizeRem = 6;
  const wrapperSizeRem = defaultWrapperSizeRem * scaleFactor;
  const iconSizeRem = defaultIconSizeRem * scaleFactor;

  return (
    <div
      data-testid="empty-video-placeholder"
      style={{
        width: `${dimension.width}px`,
        height: `${dimension.height}px`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#D9DADC',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'white',
          borderRadius: '50%',
          width: `${wrapperSizeRem}rem`,
          height: `${wrapperSizeRem}rem`,
        }}
      >
        <IcoPlayDisabledRounded color="#757677" width={`${iconSizeRem}rem`} height={`${iconSizeRem}rem`} />
      </div>
    </div>
  );
}
